import AdCampaignService from '@/bundles/Ad/services/AdCampaignService';
import { http } from '@/bundles/Http/factory/HttpFactory';
import AdCampaignToMapper from '@/bundles/Ad/mappers/AdCampaignToMapper';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

function adCampaignServiceFactory() {
  return new AdCampaignService({
    transport: http,
    errorMapper: new ErrorMapper(),
    recordMapper: new AdCampaignToMapper(),
  });
}

export const adCampaignService = adCampaignServiceFactory();
